/* =====================================================================
   TARNOVSKI case-study template — sections.js
   Progressive enhancement ONLY. No carousel auto-advance (a11y).
   - Enhances .tk-carousel with prev/next buttons + keyboard.
   - Respects prefers-reduced-motion (no smooth scroll).
   Runs only inside .tk-cs. Vanilla, no dependencies.
   ===================================================================== */
(function () {
  'use strict';
  var scope = document.querySelector('.tk-cs');
  if (!scope) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smooth = reduce ? 'auto' : 'smooth';

  function enhanceCarousel(carousel) {
    if (carousel.hasAttribute('data-enhanced')) return;
    carousel.setAttribute('data-enhanced', '');

    var wrap = document.createElement('div');
    wrap.className = 'tk-carousel__controls';
    wrap.style.cssText = 'display:flex;justify-content:flex-end;gap:8px;margin-bottom:10px';

    function btn(label, text) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tk-carousel__btn';
      b.setAttribute('aria-label', label);
      b.textContent = text;
      return b;
    }
    var prev = btn('Previous slide', '‹');
    var next = btn('Next slide', '›');
    wrap.appendChild(prev); wrap.appendChild(next);
    carousel.parentNode.insertBefore(wrap, carousel);

    function step(dir) {
      var slides = carousel.children;
      if (!slides.length) return;
      var w = slides[0].getBoundingClientRect().width + 14; // gap
      carousel.scrollBy({ left: dir * Math.max(w, carousel.clientWidth * 0.8), behavior: smooth });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });

    // Keyboard when carousel or its children focused
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });

    // role/aria
    carousel.setAttribute('role', 'group');
    carousel.setAttribute('aria-label', 'Carousel');
    Array.prototype.forEach.call(carousel.children, function (s, i) {
      s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', (i + 1) + ' of ' + carousel.children.length);
    });
  }

  var carousels = scope.querySelectorAll('.tk-carousel');
  Array.prototype.forEach.call(carousels, enhanceCarousel);
})();
